// components/Contact.js
import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Lead request submitted:', formData);
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-section-container" id="contact">
      <div className="contact-inner">
        <div className="contact-info-col">
          <h2>{t('contact.title')}</h2>
          <p className="contact-info-desc">{t('contact.description')}</p>

          <div className="contact-channels">
            <div className="contact-channel-card">
              <div className="channel-icon-wrap">
                <Mail size={20} color="#ffffff" />
              </div>
              <div className="channel-content">
                <h4>{t('contact.channels.email')}</h4>
                <a href="mailto:info@conveks.com">info@conveks.com</a>
              </div>
            </div>

            <div className="contact-channel-card">
              <div className="channel-icon-wrap">
                <Phone size={20} color="#ffffff" />
              </div>
              <div className="channel-content">
                <h4>{t('contact.channels.phone')}</h4>
                <a href="tel:+905445956696">+90 (544) 595-6696</a>
              </div>
            </div>

            <div className="contact-channel-card">
              <div className="channel-icon-wrap">
                <MapPin size={20} color="#ffffff" />
              </div>
              <div className="channel-content">
                <h4>{t('contact.channels.location')}</h4>
                <p>{t('contact.channels.istanbulTurkey')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-form-col">
          <div className="glass-card contact-form-card">
            {submitted ? (
              <div className="form-success-message">
                <div className="success-icon">✓</div>
                <h3>{t('contact.successTitle')}</h3>
                <p>{t('contact.successMsg')}</p>
                <button 
                  className="btn btn-outline" 
                  onClick={() => setSubmitted(false)}
                  style={{ marginTop: '1.5rem' }}
                >
                  {t('contact.sendAnother')}
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">{t('contact.nameLabel')}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-grid-row">
                  <div className="form-group">
                    <label htmlFor="email">{t('contact.emailLabel')}</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">{t('contact.phoneLabel')}</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">{t('contact.subjectLabel')}</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t('contact.messageLabel')}</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-block">
                  {t('contact.submitBtn')}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;